module.exports = __webpack_public_path__ + "img/hz_2.8757b07a.jpg";